module.exports = __webpack_public_path__ + "static/media/jest.4b50d2a2978c4a3bdcd6b357fea19e8c.svg";